// extracted by mini-css-extract-plugin
module.exports = {"textareaQuestion":"textareaQuestion___2qVXH"};